/*
  Message plugin for Podio. Shows yellow feedback boxes in the interface.
*/
(function($) {

  $.fn.balloon = function(settings) {
    var config = {
      'position':'below',
      'sticky':'nonsticky',
      'visible':true,
      'hint': false,
      'allowMultiple': true,
      'style' :'',
      'clickToggles': false,
      'hideOnOutsideClick': false
    };

    var persist = false;
    var elmBalloon;

    if (settings) {
      settings = $.extend(config, settings);
    } else {
      settings = config;
    }

    this.each(function() {
      if( settings.allowMultiple || !$('.balloon').length) {
        var elmTarget = $(this);
        var message = config.message || _.escape(elmTarget.attr('data-description')) || null;
        
        var elmBalloonInstance = null;

        if(message) {
          message = message.replace(/\n/g, '<br>');
          var htmlBalloon = '<div class="balloon ' + config.sticky + ' ' + config.style + ' ' + config.position+' '+(config.hint ? 'hint' : '')+'"><div class="balloon-inner"><div class="balloon-message"></div>';
          if(!config.hint) {
            htmlBalloon += '<div class="close icon-16 icon-x-black2" data-id="'+config.id+'"><span>x</span></div>';
          }
          htmlBalloon += '<br style="clear:both;"></div><div class="arrow"><div class="arrow-border"></div></div></div>';

          elmBalloonInstance = $(htmlBalloon);
          elmBalloonInstance.find('.balloon-message').html(message);

          if(config.maxMessageWidth) {
            elmBalloonInstance.find('.balloon-message').css('width', config.maxMessageWidth);
          }

          $('body').append(elmBalloonInstance);

          elmTarget.bind('remove-balloon', function() {
            elmBalloonInstance.remove();
          });

          if(config.hint) {
            var elmInputs = elmTarget.find('input,select,textarea');
            elmInputs.focus(function(){
              showBalloon(elmTarget, elmBalloonInstance);
              persist = true;
            }).blur(function(){
              elmBalloonInstance.hide();
              persist = false;
            });
            elmTarget.hover(function(){
              if (persist === false) {
                showBalloon(elmTarget, elmBalloonInstance);
              }
            }, function(){
              if (persist === false) {
                elmBalloonInstance.hide();
              }
            });
          } else {
            elmBalloon = elmBalloonInstance;
            var offset = elmTarget.offset();

            if(config.offset) {
              var settingsOffset = config.offset.split(',');
              offset.left = (offset.left + parseInt(settingsOffset[0], 10));
              offset.top = (offset.top + parseInt(settingsOffset[1], 10));
            }

            if (config.position == 'below') {
              elmBalloon.css('top', offset.top+elmTarget.outerHeight());
              elmBalloon.css('left', offset.left+(elmTarget.width()/2)-50);
            }
            else if (config.position == 'left') {
              elmBalloon.css('top', offset.top+(elmTarget.height()/2)-20);
              elmBalloon.css('left', offset.left-elmBalloon.width()-10);
            }
            else if (config.position == 'left top') {
              elmBalloon.css('top', offset.top);
              elmBalloon.css('left', offset.left-elmBalloon.width()-10);
            }
            else if (config.position == 'right') {
              elmBalloon.css('top', offset.top+(elmTarget.height()/2)-20);
              elmBalloon.css('left', offset.left + elmTarget.width());
            }
            else if (config.position == 'above') {
              elmBalloon.css('top', offset.top-elmBalloon.height()-10);
              elmBalloon.css('left', offset.left-20);
            }

            elmBalloon.find('.close').click(function(e){

              elmBalloon.fadeOut('fast', function(){
                if(!settings.clickToggles) {
                  elmBalloon.remove();
                }

                if(settings.onClose) {
                  settings.onClose(elmBalloon);
                }

                e.preventDefault();
              });
            });

            if(settings.clickToggles) {
              elmTarget.click(function(e) {
                if(elmBalloonInstance.is(':visible')) {
                  elmBalloon.find('.close').trigger('click');

                  elmBalloonInstance.unbind('outsideclick');

                } else {
                  elmBalloonInstance.fadeIn('fast');

                  if (settings.hideOnOutsideClick) {
                    _.defer(function(){
                      elmBalloonInstance.bind('outsideclick', onOutsideClick.curry(elmBalloonInstance));
                    });
                  }
                }
                e.preventDefault();
              });
            }

          }

          if(config.zIndex) {
            elmBalloonInstance.css('z-index', config.zIndex);
          }

          if(config.visible) {
            elmBalloonInstance.show();
          }
        }
      }
    });

    return elmBalloon;
  };

  function onOutsideClick(elmBalloonInstance, e) {
    if ($(e.target).is('.balloon') || $(e.target).parents('.balloon').length) {
      return;
    }
    elmBalloonInstance.hide();
    elmBalloonInstance.unbind('outsideclick');
  }


  function showBalloon(elmTarget, elmBalloon) {
    var offset = elmTarget.offset();
    var top = offset.top+10;
    var left = offset.left + elmTarget.outerWidth()+20;
    elmBalloon.css('top', top).css('left', left);
    elmBalloon.show();

    if (typeof(settings) != 'undefined' && settings.hideOnOutsideClick) {
      elmBalloon.bind('outsideclick', onOutsideClick.curry(elmBalloon));
    }
  }

})(jQuery);

define("lib/jquery/jquery.balloon", ["jquery"], function(){});

